import { render, staticRenderFns } from "./CourseReserved.vue?vue&type=template&id=2544b4ae&scoped=true&"
import script from "./CourseReserved.vue?vue&type=script&lang=js&"
export * from "./CourseReserved.vue?vue&type=script&lang=js&"
import style0 from "./CourseReserved.vue?vue&type=style&index=0&id=2544b4ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2544b4ae",
  null
  
)

export default component.exports